module.exports = __webpack_public_path__ + "static/media/birthday.f454a5b4.jpeg";